import { useMemo } from "react";

import type { PredefinedValueType } from "app/pages/sales-intelligence/sub-modules/management/store/type";

import { TypeChip } from "../components/TypeChip";
import { StyledExampleCell } from "../styles";
import { isPickListField, isPreDefinedField, isTechnographicsField } from "../utils";

import ExamplePredefinedCell from "./ExamplePredefinedCell";
import PickListCell from "./PickListCell";
import type { ExampleCellType } from "./types";

export const ExampleCell = ({
    onChange,
    onBlur,
    onClick,
    value,
    example,
    isDisabled,
    externalField,
    setting,
    focusIdx,
    index,
    tableLength,
    exportName,
    columns,
    TechnographicsCellComponent,
}: ExampleCellType) => {
    const isPreDefined = isPreDefinedField(setting);
    const isTechnographics = isTechnographicsField(setting);
    const isPickList = isPickListField(setting.externalField, columns);

    const dataType = useMemo((): PredefinedValueType => {
        if (columns.length && externalField) {
            const current = columns.filter((option) => option.name === externalField);

            return current[0]?.dataType || ("Text" as PredefinedValueType);
        }

        return "Text";
    }, [columns, externalField]);

    const pickListOptions = useMemo(
        () => columns.find(({ name }) => name === externalField)?.pickListItems,
        [columns, externalField],
    );

    const typeChip = setting.valueType ? <TypeChip valueType={setting.valueType} /> : null;

    if (isTechnographics) {
        return (
            <TechnographicsCellComponent
                value={value}
                setValue={onChange}
                index={index}
                tableLength={tableLength}
                setting={setting}
                dataType={dataType}
            />
        );
    }

    if (isPreDefined) {
        const predefinedCell = isPickList ? (
            <PickListCell
                value={value}
                setValue={onChange}
                index={index}
                tableLength={tableLength}
                options={pickListOptions}
                setting={setting}
                dataType={dataType}
                exportName={exportName}
            />
        ) : (
            <ExamplePredefinedCell
                dataType={dataType}
                value={value}
                externalField={externalField}
                isDisabled={isDisabled}
                index={index}
                onClick={onClick}
                onBlur={onBlur}
                onChange={onChange}
                setting={setting}
                focusIdx={focusIdx}
            />
        );

        return predefinedCell;
    }

    return (
        <StyledExampleCell>
            {example}
            {typeChip}
        </StyledExampleCell>
    );
};
